// removed by extract-text-webpack-plugin
module.exports = {"CustomTooltipProfitloss":"CustomTooltipProfitloss"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/Portfolio/CustomTooltipProfitLoss/styles.scss
// module id = 2010
// module chunks = 10